<div style="height: 100vh; width: 100vw;" class="text-center p-5" *ngIf="error">
    <h1>{{error}}</h1>
</div>

<div class="card card-border-color card-border-color-primary mx-auto my-3" style="width: 400px" *ngIf="receipt">
    <div class="card-header text-center">
        <!-- <img src="assets/img/logo.png" style="width: 75%" class="my-5"> -->
        <img class="my-5" style="width: 75%"
            [src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + receipt.venueKey + '/logo.png'"
            onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/logo.jpg'" />
        <div class="card-body pt-0">

            <div *ngIf="receipt" class="text-left">
                <div>{{receipt.venueName}}</div>
                <div>{{receipt?.created | amDateFormat:'LL'}}</div>

                <div class="mt-3 py-3 border-top border-bottom">
                    <div *ngFor="let transaction of receipt.transactions" class="d-flex">
                        <div class="me-3">
                            <span *ngIf="transaction.type === 1">Payment</span>
                            <span *ngIf="transaction.type === 2">Void</span>
                        </div>
                        <div class="me-3">
                            {{transaction.amount | currency}}
                        </div>
                        <div class="ms-auto">
                            {{transaction.created | amDateFormat:'LL'}}
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="mt-3">Items</h4>
            <div *ngFor="let item of receipt.items" class="d-flex">
                <div *ngIf="!item.level">{{item.quantity}} {{item.name}}</div>
                <div *ngIf="item.level > 0" class="ms-4">{{item.name}}</div>

                <div class="ms-auto" *ngIf="item.amount > 0">{{item.amount * item.quantity | currency}}</div>
            </div>

            <div class="mt-3 py-3 border-top border-bottom">
                <div class="d-flex">
                    <div>
                        Subtotal
                    </div>
                    <div class="ms-auto">
                        {{receipt.subtotal | currency}}
                    </div>
                </div>
                <div class="d-flex">
                    <div>
                        Tax
                    </div>
                    <div class="ms-auto">
                        {{receipt.taxtotal | currency}}
                    </div>
                </div>
                <div class="d-flex">
                    <div>
                        Total
                    </div>
                    <div class="ms-auto">
                        {{receipt.total | currency}}
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>